import { Button, Dropdown, Space } from '@/components';
import { ProjectResourceGuard } from '@/features/authentication/_components/ProjectResourceGuard';
import { PublishedProjectMutableGuard } from '@/features/authentication/_components/PublishedProjectMutableGuard';
import { useProject } from '@/features/project/_hooks/project';
import { useId } from '@/hooks';
import { DownOutlined } from '@ant-design/icons';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useProjectDetailDrawerState } from './ProjectDrawerStateProvider';

export const InputPriorItemButton: FC = () => {
  const { t } = useTranslation();
  const { id } = useId();
  const project = useProject(id);
  const { setDrawerState } = useProjectDetailDrawerState();

  if (
    !project.data ||
    project.data.isLocked ||
    project.data.sheetType !== 'RS'
  ) {
    return null;
  }

  return (
    <PublishedProjectMutableGuard>
      <ProjectResourceGuard onlyEdit>
        <Dropdown
          menu={{
            items: [
              {
                key: 'upsert-prior-execution',
                label: t('input-prior-execution'),
              },
              {
                key: 'upsert-prior-reserve',
                label: t('input-prior-reserve-budget'),
              },
            ],
            onClick: (e) => {
              switch (e.key) {
                case 'upsert-prior-execution':
                  setDrawerState({
                    open: true,
                    type: 'prior-execution-item',
                  });
                  break;
                case 'upsert-prior-reserve':
                  setDrawerState({
                    open: true,
                    type: 'prior-reserve-budget-item',
                  });
                  break;
                default:
              }
            },
          }}
        >
          <Button type="primary">
            <Space>
              {t('input-prior-value')}
              <DownOutlined aria-label="" />
            </Space>
          </Button>
        </Dropdown>
      </ProjectResourceGuard>
    </PublishedProjectMutableGuard>
  );
};
